module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-8 col-md-offset-2 col-lg-8 col-lg-offset-2"
  }, [_c('div', {
    staticClass: "admin-page-group"
  }, [_c('h1', {
    staticClass: "admin-page"
  }, [_vm._v("Crear Combo")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn-link pull-right",
    attrs: {
      "to": "/combos"
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-left"
  }), _vm._v(" "), _c('span', {
    staticClass: "semibold"
  }, [_vm._v("Volver al listado de Combos")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "box-style line-top"
  }, [_c('form', {
    staticClass: "form smart-form"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Elija el nombre para su combo")]), _vm._v(" "), _c('div', {
    staticClass: "input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.datosCombo.nombre),
      expression: "datosCombo.nombre"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Ej: Entrada + Plato Principal + Postre"
    },
    domProps: {
      "value": (_vm.datosCombo.nombre)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.datosCombo.nombre = $event.target.value
      }
    }
  }), _vm._v(" "), (!_vm.$v.datosCombo.nombre.required && _vm.datosCombo.mostrarErrores) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v("El nombre no puede estar vacío")]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-4 col-md-6 col-lg-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Categoría")]), _vm._v(" "), _c('div', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formAgregar.idCategoria),
      expression: "formAgregar.idCategoria"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.formAgregar.idCategoria = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', [_vm._v("Elija...")]), _vm._v(" "), _vm._l((_vm.categorias), function(categoria) {
    return _c('option', {
      domProps: {
        "value": categoria._id
      }
    }, [_vm._v(_vm._s(categoria.nombre))])
  })], 2), _vm._v(" "), _c('i', {
    staticClass: "fa fa fa-angle-down"
  })]), _vm._v(" "), (!_vm.$v.formAgregar.idCategoria.required && _vm.formAgregar.mostrarErrores) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v("Debe seleccionar una categoría")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-2 col-md-2 col-lg-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Cantidad")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formAgregar.cantidad),
      expression: "formAgregar.cantidad"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "min": "1",
      "max": "9999"
    },
    domProps: {
      "value": (_vm.formAgregar.cantidad)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.formAgregar.cantidad = $event.target.value
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), (!_vm.$v.formAgregar.cantidad.between && _vm.formAgregar.mostrarErrores) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v("Debe agregar por lo menos una categoría")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-2 col-md-2 col-lg-3"
  }, [_c('div', {
    staticClass: "form-group no-label"
  }, [_c('button', {
    staticClass: "btn btn-fill",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.clickAgregarRegla($event)
      }
    }
  }, [_vm._v("AGREGAR")])])])])]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "table-container"
  }, [_c('table', {
    staticClass: "table table-hover table-stripped table-no-first-pad"
  }, [_vm._m(3), _vm._v(" "), _vm._l((_vm.datosCombo.reglas), function(regla, idx) {
    return _c('tbody', {
      key: regla.categoria
    }, [_c('tr', [_c('td', [_vm._v(_vm._s(regla.categoria.nombre))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(regla.cantidad))]), _vm._v(" "), _c('td', [_c('ul', {
      staticClass: "table-actions smart-form"
    }, [_c('li', [_c('a', {
      staticClass: "btn btn-xs btn-ghost",
      attrs: {
        "href": "",
        "type": "button"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.eliminarRegla(idx)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-actions fa-times"
    })])])])])])])
  })], 2), _vm._v(" "), (!_vm.$v.datosCombo.reglas.minLength && _vm.datosCombo.mostrarErrores) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v("Valor no válido")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row text-center center-block"
  }, [_c('button', {
    staticClass: "btn btn-fill",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.clickGuardarCombo($event)
      }
    }
  }, [_vm._v("Guardar combo")])])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header subline-top"
  }, [_c('h2', [_vm._v("SETEAR NUEVO COMBO")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 col-sm-1 col-md-2 col-lg-1"
  }, [_c('b', {
    staticClass: "label-rules"
  }, [_vm._v("Regla:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header subline-top"
  }, [_c('h2', [_vm._v("REGLAS DE COMBOS CREADAS")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Categoría")]), _vm._v(" "), _c('th', [_vm._v("Cantidad")]), _vm._v(" "), _c('th')])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-98ccc390"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Combos/FormCombo.vue
// module id = 1157
// module chunks = 5